<template>
  <div>
    <home-loan-banner></home-loan-banner>
    <home-strength-intro
      :imgurl=convenient
      :isSecond=false
      slogan="快捷方便"
      description="在线评级，门槛低，快速申请，快速放款"></home-strength-intro>
    <home-strength-intro
      :imgurl=onlineOrder
      :isSecond=true
      slogan="线上下单"
      description="第三方在线支付，先提货后款"></home-strength-intro>
    <home-strength-intro
      :imgurl=freeFee
      :isSecond=false
      slogan="免费手续费"
      description="无抵押，免担保，最低每日0利率"></home-strength-intro>
    <home-strength-intro
      :imgurl=flexRepay
      :isSecond=true
      slogan="灵活还款"
      description="随借随还，按日利息"></home-strength-intro>
    <home-strength-intro
      :imgurl=limitLift
      :isSecond=false
      slogan="额度提升"
      description="经常使用，快速提升额度"></home-strength-intro>
  </div>
</template>

<script>
  import HomeStrengthIntro from '../HomeServiceIntro.vue'
  import HomeLoanBanner from './HomeLoanBanner'
  export default {
    name: 'HomeLoanContent',
    components: {
      HomeLoanBanner, HomeStrengthIntro
    },
    data () {
      return {
        convenient: '/static/img/service_intro/loan/convenient.png',
        onlineOrder: '/static/img/service_intro/loan/online-order.png',
        freeFee: '/static/img/service_intro/loan/free-fee.png',
        flexRepay: '/static/img/service_intro/loan/flex-repay.png',
        limitLift: '/static/img/service_intro/loan/limit-lift.png'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HomeLoanContent.vue?f4f830a0